var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1624_22330)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 14.5V5.5C6 5.23478 6.10536 4.98043 6.29289 4.79289C6.48043 4.60536 6.73478 4.5 7 4.5H19L26 11.5V14.5",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 4.5V11.5H26",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.26268 26.5V19.2273H7.85501C8.42082 19.2273 8.88957 19.3303 9.26126 19.5362C9.63294 19.7422 9.91112 20.0239 10.0958 20.3814C10.2804 20.7365 10.3728 21.1366 10.3728 21.5817C10.3728 22.0291 10.2792 22.4316 10.0922 22.7891C9.90756 23.1442 9.62821 23.4259 9.25415 23.6342C8.88247 23.8402 8.4149 23.9432 7.85146 23.9432H6.06879V23.0128H7.75202C8.10951 23.0128 8.39951 22.9512 8.62205 22.8281C8.84459 22.7027 9.00794 22.5322 9.11211 22.3168C9.21628 22.1013 9.26836 21.8563 9.26836 21.5817C9.26836 21.3071 9.21628 21.0632 9.11211 20.8501C9.00794 20.6371 8.84341 20.4702 8.6185 20.3494C8.39596 20.2287 8.1024 20.1683 7.73782 20.1683H6.35998V26.5H5.26268ZM14.8136 26.5H12.4592V19.2273H14.8881C15.6007 19.2273 16.2127 19.3729 16.7241 19.6641C17.2354 19.9529 17.6272 20.3684 17.8995 20.9105C18.1741 21.4503 18.3114 22.0978 18.3114 22.853C18.3114 23.6106 18.1729 24.2616 17.896 24.8061C17.6213 25.3506 17.2236 25.7696 16.7028 26.0632C16.1819 26.3544 15.5522 26.5 14.8136 26.5ZM13.5565 25.5412H14.7532C15.3072 25.5412 15.7676 25.437 16.1346 25.2287C16.5015 25.018 16.7762 24.7138 16.9585 24.3161C17.1407 23.916 17.2319 23.4283 17.2319 22.853C17.2319 22.2824 17.1407 21.7983 16.9585 21.4006C16.7785 21.0028 16.5098 20.701 16.1523 20.495C15.7949 20.2891 15.351 20.1861 14.8207 20.1861H13.5565V25.5412ZM20.476 26.5V19.2273H24.9859V20.1719H21.5733V22.3878H24.6627V23.3288H21.5733V26.5H20.476Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1624_22330"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.9f64f7dad71064aca2c8ed17d42059c6.svg";
export { ForwardRef as ReactComponent };